// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("assets/img/match/bg-golf-groot.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".example-bg[data-v-1bc5c84c]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.benefits-block[data-v-1bc5c84c]{min-height:60vh}@media (min-width:769px){.benefits-block[data-v-1bc5c84c]{-moz-columns:2;column-count:2;grid-column-gap:10%;-moz-column-gap:10%;column-gap:10%}}.benefits-block[data-v-1bc5c84c]  h2{color:#fff}", ""]);
// Exports
module.exports = exports;
